export default "__VITE_ASSET__BKTKTI6l__"